import { z } from 'zod';

const categoryNamesField = z
  .array(z.string().min(1).max(100))
  .max(20, 'A vendor can have at most 20 categories');

export const createVendorSchema = z.object({
  name: z.string().min(1, 'Name is required').max(255),
  email: z.string().email().max(255).optional().nullable(),
  phone: z.string().max(50).optional().nullable(),
  // Bare domains (e.g. "example.com") are accepted; the frontend prepends
  // https:// at render time, so we don't enforce z.string().url() here.
  website: z.string().max(2048).optional().nullable(),
  // Free-text "City, State" — disambiguates same-named businesses.
  location: z.string().max(255).optional().nullable(),
  notes: z.string().max(2000).optional().nullable(),
  categoryNames: categoryNamesField.default([]),
  initialContact: z.object({
    name: z.string().min(1).max(255),
    email: z.string().email().max(255).optional().nullable(),
    phone: z.string().max(50).optional().nullable(),
    role: z.string().max(100).optional().nullable(),
  }).optional(),
});

export const updateVendorSchema = createVendorSchema.partial().extend({
  categoryNames: categoryNamesField.optional(),
});

export type CreateVendorInput = z.infer<typeof createVendorSchema>;
export type UpdateVendorInput = z.infer<typeof updateVendorSchema>;
